import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { ImportJob } from "@domain/models/ImportJob";

type Input = {
  selectedClients: Client[];
  notSelectedClients: Client[];
};

type Output = Promise<ImportJob>;

export class ImportClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly httpClientRepository: ImportRepository) {}

  execute({ selectedClients, notSelectedClients }: Input) {
    return this.httpClientRepository.importClients(selectedClients, notSelectedClients);
  }
}
